import { FileDownloadOutlined } from "@mui/icons-material";
import { CustomeDialog, LoadingButton } from "../../../shared";
import { Stack, Typography } from "@mui/material";
import { TemplateUploadSection } from "./TemplateUploadSection";
import { useRef } from "react";
import { useImmer } from "use-immer";

export const ImportFutureCostsDialog = ({
  open,
  onCancel,
  isDownloading,
  onDownLoadTemplate,
  importQuery,
}) => {
  const [file, setFile] = useImmer(null);
  const { mutate, isPending } = importQuery;
  const fileRef = useRef();

  const resetAndClose = () => {
    onCancel();
    setFile(null);
  };

  const onFileChoose = (event) => {
    setFile(event?.target?.files[0] ?? null);
  };

  const onImport = async () => {
    mutate(
      { file },
      {
        onSuccess: (data) => {
          if (data?.success) resetAndClose();
        },
      }
    );
  };

  return (
    <CustomeDialog
      title="Import Data"
      open={open}
      divider={false}
      content={
        <Stack gap="16px">
          <Typography fontSize="16px">
            Import data in bulk by uploading an Excel file. Use the provided
            template to ensure correct formatting.
          </Typography>
          <LoadingButton
            onClick={onDownLoadTemplate}
            startIcon={<FileDownloadOutlined />}
            sx={{ mr: "auto" }}
            loading={isDownloading}
          >
            Download Excel Template
          </LoadingButton>

          <TemplateUploadSection
            file={file}
            onChange={onFileChoose}
            fileRef={fileRef}
          />
        </Stack>
      }
      footer={{
        display: true,
        confirmButton: (
          <LoadingButton
            variant="contained"
            size="small"
            onClick={onImport}
            disabled={!file}
            loading={isPending}
          >
            Import
          </LoadingButton>
        ),
        onConfirm: true,
        onCancel: resetAndClose,
      }}
      sx={{
        pt: "16px",
        px: "24px",
        pb: "8px",
        // width: { sm: "636px", xs: "100%" },
      }}
    />
  );
};
